import { useBackendApi } from './backendApi';
import {
  MARKET_REQUESTS_UPDATED,
  MarketRequest,
  MarketRequestStatus
} from './marketRequestsService';
import { useEventsPublisher } from 'event-bus';

export interface UpdateRequestRequest {
  status: MarketRequestStatus;
  resultDescription: string | null;
  setupAreaId?: number,
  setupAreaVersion?: string;
}

export interface MarketRequestFilter {
  statuses?: MarketRequestStatus[];
  createdByTeamId?: number;
}

export function useMarketRequestsAdminService() {
  const nekstApi = useBackendApi();

  const eventsPublisher = useEventsPublisher();

  const updateMarketRequest = async (id: number, request: UpdateRequestRequest): Promise<MarketRequest> => {
    const result = await nekstApi.put(`/manager/marketrequests/${id}`, request) as MarketRequest;

    eventsPublisher.publish(MARKET_REQUESTS_UPDATED, {});

    return result;
  };

  const getAllMarketRequests = async (filter?: MarketRequestFilter): Promise<MarketRequest[]> => {
    const params = new URLSearchParams();

    if (filter?.statuses && filter.statuses.length > 0) {
      params.append('statuses', filter.statuses.join(','));
    }

    if (filter?.createdByTeamId) {
      params.append('createdByTeamId', filter.createdByTeamId.toString());
    }

    const queryString = params.toString();
    const url = queryString ? `/manager/marketrequests?${queryString}` : '/manager/marketrequests';

    return await nekstApi.get(url) as MarketRequest[];
  };

  const getMarketRequest = async (id: number): Promise<MarketRequest> => {
    return await nekstApi.get(`/manager/marketrequests/${id}`) as MarketRequest;
  };

  return {
    updateMarketRequest,
    getAllMarketRequests,
    getMarketRequest,
  };
}
